// 公式/数学记法 → 口语可读文本：TTS 不支持公式朗读的运行时兜底。
// 生成侧契约已要求 voice 文本口语化（platform_contract 行为核心·四），此处兜底存量内容与生成违例。
// question-runtime 通过 toString() 内嵌本函数进 iframe，单一事实源在此。
export function toSpeakableText(t) {
  if (!t) return t
  t = String(t)
  for (var i = 0; i < 3; i++) {
    t = t.replace(/\\[dD]?frac\s*\{([^{}]*)\}\s*\{([^{}]*)\}/g, '$2分之$1')
  }
  t = t.replace(/\\sqrt\s*\[(\d+)\]\s*\{([^{}]*)\}/g, '$1次根号$2')
  t = t.replace(/\\sqrt\s*\{([^{}]*)\}/g, '根号$1')
  t = t.replace(/\^\s*\{?2\}?/g, '的平方').replace(/\^\s*\{?3\}?/g, '的立方')
  t = t.replace(/\^\s*\{([^{}]*)\}/g, '的$1次方').replace(/\^([a-zA-Z0-9]+)/g, '的$1次方')
  t = t.replace(/_\s*\{([^{}]*)\}/g, ' $1').replace(/_([a-zA-Z0-9]+)/g, ' $1')
  t = t.replace(/\\times|\\cdot|×/g, ' 乘 ').replace(/\\div|÷/g, ' 除以 ').replace(/\\pm|±/g, ' 正负 ')
  t = t.replace(/\\leq?|≤/g, ' 小于等于 ').replace(/\\geq?|≥/g, ' 大于等于 ').replace(/\\neq?|≠/g, ' 不等于 ')
  t = t.replace(/\\approx|≈/g, ' 约等于 ').replace(/\\infty|∞/g, ' 无穷 ').replace(/\\%|%/g, ' 百分之 ')
  t = t.replace(/°/g, ' 度 ').replace(/′/g, ' 分 ').replace(/″/g, ' 秒 ')
  t = t.replace(/\\angle|∠/g, ' 角 ').replace(/\\triangle|△/g, ' 三角形 ').replace(/\\perp|⊥/g, ' 垂直于 ').replace(/\\parallel|∥/g, ' 平行于 ')
  var greek = { '\\pi': '派', 'π': '派', '\\alpha': '阿尔法', 'α': '阿尔法', '\\beta': '贝塔', 'β': '贝塔', '\\theta': '西塔', 'θ': '西塔', '\\lambda': '拉姆达', 'λ': '拉姆达', '\\mu': '缪', 'μ': '缪', '\\Delta': '德尔塔', 'Δ': '德尔塔', '\\omega': '欧米伽', 'ω': '欧米伽', '\\phi': '斐', 'φ': '斐' }
  Object.keys(greek).forEach(function (k) { t = t.split(k).join(greek[k]) })
  t = t.replace(/\$\$?/g, ' ').replace(/\\\(|\\\)/g, ' ')
  t = t.replace(/\\[a-zA-Z]+/g, ' ')
  t = t.replace(/[{}]/g, ' ')
  return t.replace(/\s{2,}/g, ' ').trim()
}

export function cancelAllSpeech() {
  const allWindows = [window]
  const iframes = document.querySelectorAll('iframe')
  iframes.forEach(function (iframe, i) {
    try {
      var cw = iframe.contentWindow
      if (cw) {
        allWindows.push(cw)
      } else {
      }
    } catch (e) {
    }
  })
  allWindows.forEach(function (win, i) {
    try {
      if (win.speechSynthesis) {
        var speaking = win.speechSynthesis.speaking
        var pending = win.speechSynthesis.pending
        win.speechSynthesis.cancel()
        // Chrome speech bug workaround: 空 Utterance flush 语音队列
        var empty = new win.SpeechSynthesisUtterance('')
        empty.volume = 0
        empty.onend = function () {}
        win.speechSynthesis.speak(empty)
      } else {
      }
    } catch (e) {
    }
    // 预合成音频停止(2026-10-28 语音方案): iframe 内 <audio> 不随换载自停, 与系统TTS同闸停掉
    // (宿主自身的 audio/video 由下方 document 级段落兜底, 此处重复 pause 幂等无害)
    try {
      if (win.document) {
        var innerMedias = win.document.querySelectorAll('audio, video')
        innerMedias.forEach(function (media, j) {
          try { media.pause() } catch (e) { }
        })
      }
    } catch (e) { }
  })
  var medias = document.querySelectorAll('audio, video')
  medias.forEach(function (media, i) {
    try {
      media.pause()
    } catch (e) {
    }
  })
}
